import { create } from 'zustand';

interface DraftState {
  count: number;
  draftAreaIds: Set<string>;
  setCount: (count: number) => void;
  setDraftAreaIds: (ids: string[]) => void;
  increment: () => void;
  decrement: () => void;
  addAreaId: (id: string) => void;
  removeAreaId: (id: string) => void;
}

export const useDraftStore = create<DraftState>((set) => ({
  count: 0,
  draftAreaIds: new Set(),
  setCount: (count) => set({ count }),
  setDraftAreaIds: (ids) => set({ draftAreaIds: new Set(ids) }),
  increment: () => set((s) => ({ count: s.count + 1 })),
  decrement: () => set((s) => ({ count: Math.max(0, s.count - 1) })),
  addAreaId: (id) =>
    set((s) => {
      const next = new Set(s.draftAreaIds);
      next.add(id);
      return { draftAreaIds: next };
    }),
  removeAreaId: (id) =>
    set((s) => {
      const next = new Set(s.draftAreaIds);
      next.delete(id);
      return { draftAreaIds: next };
    }),
}));
